export enum VoucherSoundType {
  buttonClick = 'Voucher_ButtonClick',
  giftIconBounce = 'Voucher_VoucherPlayingUI_GiftRetracts',
  headerShow = 'Voucher_VoucherPlayingUI_ShowUp',
  selectPopup = 'Voucher_VoucherPopUp',
  totalWinPopup = 'Voucher_VoucherTotalWin',
}
